import React, { useState } from "react";
import { connect } from "react-redux";

import {
    toSelectableCropDropdownOptions,
    useCropList,
    locationScope,
} from "~/utils/crops/use-crop-list";
import { useCropPurposeList } from "~/utils/crops/use-crop-purpose-list";
import { toLegacyCropPurposePicklistItems } from "~/utils/crops/to-legacy-crop-purpose-picklist-items";

import AddEditPanelContainer from "./../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { dropdowns, pickLists, unitTypes, service, model } from "./../data";
import { fetchDropdownData } from "~/core/dropdowns/actions";
import { getDropdown } from "~/admin/selectors";

const mapStateToProps = (state) => ({
    [model.PROPS_GROWTH_STAGE_ORDER]: getDropdown(model.PROPS_GROWTH_STAGE_ORDER, state),
});

const mapDispatchToProps = () => ({
    fetchGrowthStage: (v) => fetchDropdownData(v),
});

const ConnectedAddEditPanel = connect(
    mapStateToProps,
    mapDispatchToProps
)(
    AddEditPanelContainer(AddEditPanel, {
        dropdowns,
        pickLists,
        unitTypes,
        service,
    })
);

const AddEditContainer = (props) => {
    const [selectedOrgLevelGuids, setSelectedOrgLevelGuids] = useState([]);
    // One location -> that location; none or several -> Catalog.
    const cropScope = locationScope(selectedOrgLevelGuids);
    const { crops } = useCropList({ scope: cropScope });
    const { cropPurposes } = useCropPurposeList({ scope: cropScope });

    return (
        <ConnectedAddEditPanel
            {...props}
            onOrgLevelGuidsChange={setSelectedOrgLevelGuids}
            {...{
                [model.PROPS_CROP_NAME]: toSelectableCropDropdownOptions(crops),
                [model.PROPS_CROP_PURPOSE_LIST]: toLegacyCropPurposePicklistItems(cropPurposes),
            }}
        />
    );
};

export default AddEditContainer;
